import Icon from "@mui/material/Icon/Icon"
import IconButton from "@mui/material/IconButton/IconButton"
import ListItem from "@mui/material/ListItem/ListItem"
import ListItemIcon from "@mui/material/ListItemIcon/ListItemIcon"
import ListItemText from "@mui/material/ListItemText/ListItemText"
import { memo } from "preact/compat"
import { Draggable } from "react-beautiful-dnd"
import type { Item } from "./EditableList"
import { dragIconLigature } from "./experiments"

export const DraggableListItem = memo(function DraggableListItem({
  item,
  index,
  onRemoveItem,
}: {
  item: Item
  index: number
  onRemoveItem: (id: string) => void
}) {
  return (
    <Draggable draggableId={item.id} index={index}>
      {/* @ts-ignore */}
      {(provided) => (
        // @ts-ignore
        <ListItem
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          secondaryAction={
            <IconButton
              onClick={() => onRemoveItem(item.id)}
              edge="end"
              aria-label="delete"
            >
              <Icon children="close" />
            </IconButton>
          }
        >
          <>
            <ListItemIcon>
              <Icon children={dragIconLigature as string} />
            </ListItemIcon>
            
            <ListItemText primary={item.content} />
            </>
        </ListItem>
      )}
    </Draggable>
  )
})
